module.exports = __webpack_public_path__ + "static/media/13ITC3.7541314d.jpg";